// @flow
import { captureException } from '@sentry/react'
import * as pdfFillerApi from 'api/pdfFillerApi'
import Loading from 'components/Loading'
import * as React from 'react'
import { useHistory } from 'react-router-dom'
import DraggableFileUpload from 'ui/atoms/DraggableFileUpload'
import FlatCard from 'ui/atoms/FlatCard'
import Space from 'ui/atoms/Space'
import Page from 'ui/organisms/Page'
import PrimaryButton from 'ui/PrimaryButton'
import { ZentakeContext } from 'utils/ZentakeContext'

function FileUpload(): React.Node {
  const history = useHistory()
  const [loading, setLoading] = React.useState(false)
  const { teamDetails } = React.useContext(ZentakeContext)
  const [file, setFile] = React.useState<null | File>(null)

  const postFile = React.useCallback(() => {
    if (!teamDetails) return
    if (!file) return

    setLoading(true)

    const formData = new FormData()
    formData.append('file', file)
    formData.append('filename', file.name)

    pdfFillerApi
      .createPdfDocument(formData)
      .then((response) => {
        history.push(`/pdf/${response.id}/edit`)
      })
      .catch((error) => {
        captureException(error)
        alert('an error has occurred')
      })
      .finally(() => {
        setLoading(false)
      })
  }, [teamDetails, file, history])

  const handleInputChange = (files: File[]) => {
    if (files.length === 0) {
      setFile(null)
    } else {
      setFile(files[0])
    }
  }

  return (
    <Page title="Upload Document">
      <FlatCard>
        {!loading ? (
          <Space>
            <DraggableFileUpload accept=".pdf" onChange={handleInputChange} />
            <PrimaryButton disabled={!file} onClick={postFile} type="button">
              Continue
            </PrimaryButton>
          </Space>
        ) : (
          <Loading className="!h-60" />
        )}
      </FlatCard>
    </Page>
  )
}

export default FileUpload
